import React from 'react'
import Layout from 'common/components/Layout'
import TeamReportPage from '../components/TeamReportPage'

function TeamReportDashboard() {
    return (
        <Layout>
            <TeamReportPage />
        </Layout>
    )
}

export default TeamReportDashboard
